import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CanActivateGuard } from './../shared/index';

import { AnnotationIndexComponent, AnnotationResolve } from './index';

export const AnnotationRoutes: Routes = [
    {
        path: 'annotations',
        component: AnnotationIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'annotations/:annotationId',
        component: AnnotationIndexComponent,
        canActivate: [CanActivateGuard],
        resolve: {
            annotation: AnnotationResolve
        }
    }
];

export const AnnotationRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(AnnotationRoutes);
